import { useState } from 'react';
import { getErrorMessage } from '@/lib/platform';
import { Sheet } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { Stars } from '@/components/ui/stars';

export function RateRideModal({
  onClose,
  onSubmit,
  title = 'Rate your ride',
}: {
  onClose: () => void;
  onSubmit: (value: string) => Promise<void>;
  title?: string;
}) {
  const [value, setValue] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function submit() {
    if (value < 1) return;
    setSubmitting(true);
    setError('');
    try {
      await onSubmit(String(value));
    } catch (e) {
      setError(getErrorMessage(e));
      setSubmitting(false);
    }
  }

  return (
    <Sheet
      open
      onClose={onClose}
      title={title}
      footer={
        <div className="wb-row wb-gap-8" style={{ justifyContent: 'flex-end' }}>
          <Button variant="ghost" size="sm" onClick={onClose}>
            Skip
          </Button>
          <Button variant="primary" size="sm" onClick={submit} disabled={submitting || value < 1}>
            {submitting ? 'Sending…' : 'Submit'}
          </Button>
        </div>
      }
    >
      <div className="wb-col wb-center wb-gap-12" style={{ padding: '8px 0' }}>
        <Stars value={value} onRate={setValue} size={38} />
        {error && (
          <p className="wb-small" style={{ color: 'var(--danger)' }}>
            {error}
          </p>
        )}
      </div>
    </Sheet>
  );
}
